(function () {
  var loadListenerAdded = false;

  function revealBorders(container) {
    if (!container) return;
    container.classList.remove("scroll-borders--pending");
    container.classList.add("scroll-borders--initialized");
  }

  function destroyBorderAnimations(container) {
    if (!container || !container._svBorderTweens) return;
    container._svBorderTweens.forEach(function (tween) {
      var stTr = tween.scrollTrigger;
      tween.kill();
      if (stTr) stTr.kill();
    });
    container._svBorderTweens = null;
  }

  function scheduleRevealAndRefresh(container) {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        try {
          if (typeof ScrollTrigger !== "undefined") ScrollTrigger.refresh();
        } catch (e) {
          /* ignore */
        }
        revealBorders(container);
      });
    });
  }

  function initScrollingBorders() {
    var container = document.querySelector(".scroll-borders");
    if (!container) return;

    if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
      console.warn("GSAP or ScrollTrigger not loaded");
      revealBorders(container);
      return;
    }

    try {
      gsap.registerPlugin(ScrollTrigger);
    } catch (err) {
      console.warn("Scrolling borders: ScrollTrigger register failed", err);
      revealBorders(container);
      return;
    }

    destroyBorderAnimations(container);
    container._svBorderTweens = [];

    try {
      var rawSelector = (container.dataset.targetSelector || "")
        .trim()
        .split(/[\r\n]+/)[0]
        .trim();
      var fallbackSelector = "#MainContent";
      var selector = rawSelector || fallbackSelector;
      var anchor = null;
      try {
        anchor = document.querySelector(selector);
      } catch (err) {
        console.warn("Scrolling borders: invalid selector", selector, err);
      }
      if (!anchor && selector !== fallbackSelector) {
        try {
          anchor = document.querySelector(fallbackSelector);
        } catch (e) {
          /* ignore */
        }
      }
      if (anchor) {
        anchor.classList.add("scroll-borders-anchor");
        anchor.appendChild(container);
        container.classList.add("scroll-borders--in-wrap");
      }

      var speed = parseFloat(container.dataset.speed) || 0.4;

      var smoothWrapper = document.querySelector("#smooth-wrapper");
      var smoothContent = document.querySelector("#smooth-content");
      var triggerEl = smoothContent || document.body;

      function getScrollableHeight() {
        if (smoothContent) {
          return smoothContent.scrollHeight;
        }
        return Math.max(
          document.documentElement.scrollHeight,
          document.body.scrollHeight
        );
      }

      var inners = container.querySelectorAll(".border-inner");
      inners.forEach(function (el) {
        gsap.set(el, {
          y: 0,
          force3D: true,
          immediateRender: true
        });

        var st = {
          trigger: triggerEl,
          start: "top top",
          end: "max",
          scrub: true,
          invalidateOnRefresh: true
        };
        if (smoothWrapper) {
          st.scroller = smoothWrapper;
        }

        var tween = gsap.fromTo(
          el,
          {
            y: 0
          },
          {
            y: function () {
              return getScrollableHeight() * speed;
            },
            ease: "none",
            scrollTrigger: st
          }
        );
        container._svBorderTweens.push(tween);
      });

      try {
        ScrollTrigger.refresh();
      } catch (e) {
        /* ignore */
      }
    } catch (err) {
      console.warn("Scrolling borders init error:", err);
    }

    scheduleRevealAndRefresh(container);

    if (!loadListenerAdded) {
      loadListenerAdded = true;
      window.addEventListener(
        "load",
        function () {
          var c = document.querySelector(".scroll-borders");
          if (c && c.classList.contains("scroll-borders--pending")) {
            initScrollingBorders();
          } else {
            try {
              if (typeof ScrollTrigger !== "undefined") ScrollTrigger.refresh();
            } catch (e) {
              /* ignore */
            }
          }
        },
        { once: true }
      );

      window.addEventListener("resize", function () {
        try {
          if (typeof ScrollTrigger !== "undefined") ScrollTrigger.refresh();
        } catch (e) {
          /* ignore */
        }
      });
    }
  }

  function scheduleInit() {
    function kick() {
      requestAnimationFrame(function () {
        requestAnimationFrame(initScrollingBorders);
      });
    }

    if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
      var attempts = 0;
      var maxAttempts = 80;
      var t = setInterval(function () {
        attempts++;
        if (
          typeof gsap !== "undefined" &&
          typeof ScrollTrigger !== "undefined"
        ) {
          clearInterval(t);
          kick();
          return;
        }
        if (attempts >= maxAttempts) {
          clearInterval(t);
          kick();
        }
      }, 25);
      return;
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", kick, { once: true });
    } else {
      kick();
    }
  }

  document.addEventListener("shopify:section:load", function (e) {
    var target = e.target;
    if (!target || !target.querySelector) return;
    if (!target.querySelector(".scroll-borders")) return;
    requestAnimationFrame(function () {
      requestAnimationFrame(initScrollingBorders);
    });
  });

  window.initScrollingBorders = initScrollingBorders;

  scheduleInit();
})();
